import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class GlobalCheckGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    // 1. User logged in?
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    }

    return true; // allow page
  }
}
